export const constants = {
  projectDescriptionMaxLength: 3000,
  documentGenerationPollingTime: 1e3,
  wireframesListRowCount: 5,
};
